const About = () => {
  return <div></div>;
};

export default About;
